export function intTruncateString(str: string | null, maxVisibleSymbols: number, suffix = '', truncate = true): string | null {
  return truncate && (str && str.length > maxVisibleSymbols) ? `${str.substr(0, maxVisibleSymbols)}${suffix}` : str;
}

export function intTruncateEllipsis(str: string | null, maxVisibleSymbols: number, truncate = true): string | null {
  return intTruncateString(str, maxVisibleSymbols, '...', truncate);
}
